import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatuses } from 'core/common/entities';
import {
  detectScanProcessingIdle,
  detectScanProcessingStarted,
  detectScanProcessingSucceed,
  detectScanProcessingFailed,
  uploadScanProcessingIdle,
  uploadScanProcessingStarted,
  uploadScanProcessingSucceed,
  uploadScanProcessingFailed,
  updateScan,
} from './actions';
import { scanInitialState } from './state';

export const scanReducer = createReducer(scanInitialState, (builder) => {
  builder
    .addCase(detectScanProcessingIdle, (state) => {
      state.detectProcessingStatus = LoadingStatuses.IDLE;
    })
    .addCase(detectScanProcessingStarted, (state) => {
      state.detectProcessingStatus = LoadingStatuses.PENDING;
    })
    .addCase(detectScanProcessingSucceed, (state) => {
      state.detectProcessingStatus = LoadingStatuses.FULFILLED;
    })
    .addCase(detectScanProcessingFailed, (state) => {
      state.detectProcessingStatus = LoadingStatuses.FAILED;
    })
    .addCase(uploadScanProcessingIdle, (state) => {
      state.uploadProcessingStatus = LoadingStatuses.IDLE;
    })
    .addCase(uploadScanProcessingStarted, (state) => {
      state.uploadProcessingStatus = LoadingStatuses.PENDING;
    })
    .addCase(uploadScanProcessingSucceed, (state) => {
      state.uploadProcessingStatus = LoadingStatuses.FULFILLED;
    })
    .addCase(uploadScanProcessingFailed, (state) => {
      state.uploadProcessingStatus = LoadingStatuses.FAILED;
    })
    .addCase(updateScan, (state, { payload }) => {
      state.data = { ...state.data, ...payload };
    });
});
